export const DropdownItemList = [
  { name: "Payment Settings", path: "/payment-settings", color: 'red-light', icon: 'credit_card', isActive: false },
  { name: "Log out", path: "/log-out", color: 'red-light', icon: 'exit_to_app', isActive: false }
];
